// extracted by mini-css-extract-plugin
export var cancelButton = "_oe-5";
export var content = "_oe-3";
export var createButton = "_oe-6";
export var drawerContainer = "_oe-0";
export var footer = "_oe-2";
export var header = "_oe-1";
export var orderFormColumn = "_oe-4";